export default __webpack_public_path__ + "static/media/cutoff.23e27b0b.svg";